/**
 * MarketSegmentModal — full-screen modal for adding symbols to the watchlist.
 *
 * Opens a `react-modal` overlay containing `MarketSegmentList` (grouped by
 * market segment).  Collects `selectedSymbolsData` state and passes it down
 * to `SymbolList` instances.  Dismissible via close button or `onRequestClose`.
 */
import { useState } from "react";
import Modal, { Styles } from "react-modal";
import { useSelector } from "react-redux";
import { HiOutlinePlus, HiOutlineX } from "react-icons/hi";
import MarketSegmentList from "@components/market-watch/market-segment-list/MarketSegmentList";
import { getColorTheme } from "@service/local-storage-handler";
import "./market-segment-modal.scss";

Modal.setAppElement("#marketview");

const MarketSegmentModal = ({
  addMarketSegmentModalIsOpen,
  setAddMarketSegmentModalIsOpen,
}) => {
  const theme = useSelector(({ theme }) => theme.theme);
  // Default to dark if theme is not set in Redux (fallback to localStorage)
  const effectiveTheme = theme || getColorTheme() || "dark";
  const isDark = effectiveTheme === "dark";

  const [selectedSymbolsData, setSelectedSymbolsData] = useState<
    Array<Array<string>>
  >([]);

  const closeModal = () => {
    setAddMarketSegmentModalIsOpen(false);
  };

  return (
    <Modal
      isOpen={addMarketSegmentModalIsOpen}
      onRequestClose={() => setAddMarketSegmentModalIsOpen(false)}
      style={customStyles}
    >
      <div
        className={`market-segment-modal-wrapper ${isDark ? "dark" : "light"}`}
      >
        <div className="market-segment-modal">
          <div className="modal-header">
            <div className="modal-title">
              <HiOutlinePlus className="title-icon" />
              <h3>Add Symbols</h3>
            </div>
            <button onClick={closeModal} className="close-btn">
              <HiOutlineX />
            </button>
          </div>

          <div className="modal-content">
            <MarketSegmentList
              selectedSymbolsData={selectedSymbolsData}
              setSelectedSymbolsData={setSelectedSymbolsData}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MarketSegmentModal;

const customStyles: Styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    zIndex: 10001,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(4px)",
  },
  content: {
    position: "relative",
    top: "auto",
    left: "auto",
    right: "auto",
    bottom: "auto",
    width: "90%",
    maxWidth: "900px",
    maxHeight: "85vh",
    background: "none",
    border: "none",
    padding: 0,
    WebkitOverflowScrolling: "touch",
    outline: "none",
    inset: "auto",
    overflow: "visible",
  },
};
